$(document).ready(function() {
    const originalPrices = {};
    $('.varient-prices .price-label').each(function(index) {
        originalPrices[index] = parseFloat($(this).text().replace('$', ''));
    });

    function updatePrices(discountPercentage) {
        $('.varient-prices .price-label').each(function(index) {
            const originalPrice = originalPrices[index];
            const discountedPrice = originalPrice * (1 - (discountPercentage / 100));
            $(this).text(`$${discountedPrice.toFixed(2)}`);
        });
    }

    function resetPrices() {
        $('.varient-prices .price-label').each(function(index) {
            $(this).text(`$${originalPrices[index].toFixed(2)}`);
        });
    }

    $('.subify-choice-box-wrapper').on('click', function() {
        if ($(this).hasClass('active') && $(this).find('.subify-max-discount-badge-percentage').length) {
            const discountText = $(this).find('.subify-max-discount-badge-percentage').text();
            const discountPercentage = parseFloat(discountText.replace('%', ''));

            if (!isNaN(discountPercentage)) {
                setTimeout(() => {
                    updatePrices(discountPercentage);
                }, 3000); // 3 seconds delay
            }
        } else {
            resetPrices();
        }
    });
}); 



$(document).ready(function(){
  $('#shopify-section-template--23252891894039__brands_R4MgwC .hdt-slider__container').slick({
    slidesToShow: 3,    // Number of slides to show
    slidesToScroll: 1,  // Number of slides to scroll at a time
    autoplay: true,     // Enable autoplay
    autoplaySpeed: 2000, // Delay between slides in milliseconds
    arrows: true,       // Display next/prev arrows
    dots: true,         // Display dots for navigation
    infinite: true      // Infinite looping of slides
  });
});


/*********** review marquee slider **********/

$('.hdt-marquee .hdt-marquee-item .testimonial-text p').each(function() {
    if ($(this).text().trim() === '') {
        $(this).addClass('blank');
    }
});
